module.exports = __webpack_public_path__ + "static/media/bookmark.c032022e.svg";